var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 53,
    viewBox: "0 0 55 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_423",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 48,
    height: 47
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60938 3.51041H50.9976V49.5H3.60938V3.51041Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3115 31.6246C26.8217 35.9932 32.4926 37.3725 32.4926 37.3725L37.4657 32.3627C39.158 30.7236 41.1002 31.0856 43.5992 32.3424L46.2345 33.779C48.0257 34.7555 49.1567 36.5896 49.1525 38.5835C49.1524 38.599 49.1524 38.6145 49.1522 38.6301C49.1405 40.1425 48.5046 41.8637 46.9312 43.3907C43.0911 47.1175 37.832 47.7386 33.5107 47.7016C26.2187 47.6391 19.7015 43.1035 14.9071 38.4504C10.1126 33.7975 5.53089 27.5626 5.46647 20.4857C5.42825 16.2919 6.03828 11.1881 9.8783 7.46135C11.4517 5.93435 13.2254 5.31726 14.7837 5.30586C14.7998 5.30577 14.8158 5.30568 14.8318 5.30568C16.8864 5.30155 18.7762 6.3991 19.7823 8.13754L21.2626 10.695C22.3732 12.9406 22.9307 15.0052 21.2417 16.6474L16.2646 21.6542C16.2646 21.6542 17.81 27.2475 22.3115 31.6246Z",
    stroke: "#033655",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1512 25.0625C49.1512 14.1487 40.0348 5.30135 28.7891 5.30135",
    stroke: "#033655",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3424 25.0625C34.3424 22.086 31.8561 19.6731 28.7891 19.6731",
    stroke: "#033655",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7468 25.0625C41.7468 18.1174 35.9454 12.4872 28.7891 12.4872",
    stroke: "#033655",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5c5380247af4dcd870ac3b75ba1003f0.svg";
export { ForwardRef as ReactComponent };